<div class="icon-nav top-header" style="display: flex;">
  <ul class="header-dropdown">
    <!--<li *ngIf="!isLogin" class="about-nav-head">
      <a style="cursor: pointer; padding-right: 10px" target="_blank"
        >About Us</a
      >
    </li> -->

    <li class="onhover-div mobile-cart" *ngIf="!isCart && !isLocation">
      <!-- <div>
        <a [routerLink]="['/shop/checkout']">
          <img src="favicon.ico" class="img-fluid" alt="" />
          <i class="ti-shopping-cart"></i>
        </a>
      </div> -->
      <!-- <span *ngIf="itemCount != 0" class="cart_qty_cls">{{ itemCount }}</span> -->
      <!--<ul class="show-div shopping-cart" *ngIf="!products?.length">
        <h5>Your cart is currently empty.</h5>
      </ul>-->
      <!--<ul class="show-div shopping-cart" *ngIf="products.length">
        <li *ngFor="let product of products">
          <div class="media">
            <a
              [routerLink]="[
                '/shop/product/left/sidebar/',
                product?.title?.replace(' ', '-')
              ]"
            >
              <img
                class="mr-3"
                [src]="product?.images[0]?.src"
                [alt]="product?.images[0]?.alt"
              />
            </a>
            <div class="media-body">
              <a
                [routerLink]="[
                  '/shop/product/left/sidebar/',
                  product?.title?.replace(' ', '-')
                ]"
              >
                <h4>{{ product?.title }}</h4>
              </a>
              <h4>
                <span>
                  {{ product?.quantity }} x
                  {{
                    product?.price * productService?.Currency.price
                      | discount: product
                      | currency: productService?.Currency.currency:"symbol"
                  }}
                </span>
              </h4>
            </div>
          </div>
          <div class="close-circle" (click)="removeItem(product)">
            <a href="javascript:void(0)"
              ><i class="fa fa-times" aria-hidden="true"></i
            ></a>
          </div>
        </li>
        <li>
          <div class="total">
            <h5>
              subtotal :
              <span>{{
                getTotal
                  | async
                  | currency: productService?.Currency.currency:"symbol"
              }}</span>
            </h5>
          </div>
        </li>

        <li>
          <div class="buttons">
            <a [routerLink]="['/shop/cart']" class="view-cart">view cart</a>
            <a [routerLink]="['/shop/checkout']" class="checkout">checkout</a>
          </div>
        </li>
        <li>
          <a [routerLink]="">About</a>
        </li>
      </ul>-->
    </li>

    <li *ngIf="!isLogin" class="about-nav-head sign-in hideInMobile">
      <!--<button
        type="submit"
        class="btn btn-solid"
        id="mc-submit"
        (click)="loginModal()"
      >
        Sign In
      </button>-->
      <span (click)="loginModal()">Login / Sign up</span>
    </li>
    <li *ngIf="!isLogin" class="sign-in hideInWeb mobileSignIn">
      <span id="mc-submit" >
      <i class="fa fa-user-o" aria-hidden="true" (click)="loginModal()"></i>
    </span>
    </li>
    <li *ngIf="isLogin" class="onhover-dropdown mobile-account pl-1" style="position: relative;">
      <i class="fa fa-user-o web-user" aria-hidden="true"></i> {{(userName.length>20) 
                                                               ?(userName | slice:0:20)+ "..."
                                                                :(userName)}}
      <ul class="onhover-show-div">
        <li [routerLink]="['/pages/useraccount']" [queryParams]="{tab: 'myorders'}">
          <a data-lng="en"> My Orders </a>
        </li>
        <li [routerLink]="['/pages/useraccount']" [queryParams]="{tab: 'myaddress'}">
          <a data-lng="en"> My Address </a>
        </li>
        <li [routerLink]="['/pages/useraccount']" [queryParams]="{tab: 'myprofile'}">
          <a data-lng="en"> My Profile </a>
        </li>
        <li *ngIf="isAdmin" (click)="proxyLogin()">
          <a data-lng="es"> Proxy User </a>
        </li>
        <li (click)="logout()">
          <a data-lng="es"> Logout </a>
        </li>
      </ul>
    </li>
  </ul>
</div>
